import React from "react";
import Principal from "@app/model/authentication/Principal";
import Utilities from "@util/Utilities";
import LazyImage from "@app/component/image/LazyImage";
import Profile from '@app/model/profile/Profile';

type Props = {
    principal: Principal | Profile,
    isSmall?: boolean,
    addClasses?: string
}
const Avatar: React.FunctionComponent<Props> = ({principal, isSmall = false, addClasses}) => {

    const sizeClasses: string = isSmall ? "w-8 h-8" : "w-16 h-16";

    return <div className="flex items-center flex-shrink-0">
        {principal.imageUrl && <LazyImage
            placeholderClassName={
                Utilities.classNames(
                    sizeClasses,
                    "rounded-full",
                    addClasses
                )
            }
            className={
                Utilities.classNames(
                    sizeClasses,
                    "rounded-full",
                    addClasses
                )
            }
            src={principal!.imageUrl}
            alt={principal!.name}/>}
        {!principal!.imageUrl && <div
            className={
                Utilities.classNames(
                    "relative items-center justify-center",
                    sizeClasses,
                    "overflow-hidden bg-blue-500 rounded-full dark:bg-blue-600",
                    addClasses ?? 'inline-flex'
                )}>
            <span className={
                Utilities.classNames(
                    "font-medium text-white dark:text-white",
                    isSmall?"text-md":"text-xl"
                )
            }>{Utilities.getInitials(principal.name)}</span>
        </div>}
    </div>
}

export default Avatar;